import { IStaffUI } from 'types/staff';
import { isBookableStaff } from 'utils/staff';
import { ANYONE_NAILS_ID } from './helper';

/**
 * Tho duoc uu tien xep vao the dau tien cua modal gan tho.
 *
 * Anyone khong phai mot nguoi cu the nen khong duoc uu tien; tim trong danh sach tho ranh
 * truoc roi moi den danh sach toan tiem, vi tho da chon co the dang ban dung khung gio do
 * ma van phai giu o the dau.
 */
export const resolvePreferredStaff = (
  preferredId: string | null | undefined,
  available: IStaffUI[],
  shopOrder: IStaffUI[],
): IStaffUI | undefined => {
  if (!preferredId || preferredId === ANYONE_NAILS_ID) return undefined;
  return available.find(o => o.id === preferredId) || shopOrder.find(o => o.id === preferredId);
};

/**
 * Thu tu the trong modal gan tho: tho da chon o buoc truoc, roi tho dang ranh trong khung
 * gio, roi phan con lai cua tiem.
 *
 * Nhom cuoi giu cho moi the deu co nguoi ke ca khi danh sach tho ranh ngan hon so khach.
 * Id duoc khu trung de khong ai bi xep vao hai the, va Anyone bi loai vi moi the phai la
 * mot nguoi cu the. Danh sach ngan hon so khach thi tra ve dung so co that — form khong
 * duoc phep dung the rong.
 *
 * Ca hai nguon deu duoc loc tho Maintenance ngay tai day. Nguon tho ranh thuong da duoc loc
 * san o phia goi, nhung loc lai khong doi ket qua va giu cho ham khong phu thuoc vao viec
 * nguoi goi co nho loc hay khong.
 */
export const buildAssignStaffPool = (
  preferred: IStaffUI | undefined,
  available: IStaffUI[],
  shopOrder: IStaffUI[],
  totalPeople: number,
): IStaffUI[] => {
  const pool: IStaffUI[] = [];
  [
    ...(preferred ? [preferred] : []),
    ...available.filter(isBookableStaff),
    ...shopOrder.filter(isBookableStaff),
  ].forEach(o => {
    if (!o || o.id === ANYONE_NAILS_ID) return;
    if (pool.some(s => s.id === o.id)) return;
    pool.push(o);
  });
  return pool.slice(0, totalPeople);
};
